import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import global_css from './global-css';

@customElement('ri-plot')
export class Plot extends LitElement {
  data: object[] = [];
  keys: string[] = [];

  plot() {
    // const plotElement = this.shadowRoot?.getElementById('plot') as HTMLElement;
    // if (!plotElement) return;
    // const layout = {legend: {title: {side: 'top left'}}};
    // const data: object[] = [];
    // for (const key of this.keys) {
    //   data.push({
    //     x: [...Array(this.data.length).keys()],
    //     y: [
    //       ...this.data.map(
    //         (point: Record<string, ) =>
    //           (key in point ? point[key][0]?.toNumber() : 0) ?? 0
    //       ),
    //     ],
    //     type: 'scatter',
    //     mode: 'lines+markers',
    //     name: key,
    //   });
    // }
    // // Plotly.newPlot(plotElement, data, layout);
  }
  static override styles = [global_css, css``];
  override render() {
    return html`<div id="plot"></div>`;
  }
}
